import "./Majestic.css";
import Navbar from "../component/layout/Navbar";
import ProjectHighlightCard from "../component/cards/ProjectHighlightCard";
import FloorPlanCard from "../component/cards/FloorPlanCard";
import Banner from "../component/banner/Banner";
import Intro from "../component/intro/Intro";
import ApplicationForm from "../component/forms/ApplicationForm";
import Map from "../component/map/Map";
import bannerImg from "../asset/image/gensphere/path.jpg";
import FAB from "../component/fab/fab";
import Footer from "../component/layout/Footer";
import { genSphereNavLinks } from "../asset/gensphere/genSphereNavLinks";
import { genSphereHighlights } from "../asset/gensphere/genSphereHighlights";
import { genSphereIntro } from "../asset/gensphere/genSphereIntro";
import { genSphereUnitLayouts } from "../asset/gensphere/genSphereUnitLayouts";
import { Helmet } from "react-helmet-async";

function Majestic() {
  const bannerUrl = bannerImg?.default || bannerImg;
  const accentColor = "#F77E2D";

  // JSON-LD for SEO structured data
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://majestic-gensphere.com/#website",
        "url": "https://majestic-gensphere.com/",
        "name": "Gen Sphere | Majestic Gen",
        "description": "Premium JB Condo near RTS Link and CIQ Custom.",
        "publisher": { "@id": "https://majestic-gensphere.com/#agent" },
        "inLanguage": "en-US"
      },
      {
        "@type": "RealEstateListing",
        "@id": "https://majestic-gensphere.com/#listing",
        "name": "Gen Sphere by Majestic Gen | RTS JB Condo for Sale",
        "mainEntity": { "@id": "https://majestic-gensphere.com/#apartment" },
        "keywords": "Majestic Gen Sphere, Majestic Gen, Gen Sphere, RTS JB Condo, JB Condo, SG JB Condo, CIQ Condo, Custom Condo, JB Property"
      },
      {
        "@type": "RealEstateAgent",
        "@id": "https://majestic-gensphere.com/#agent",
        name: "Majestic Gen Sphere",
        url: "https://majestic-gensphere.com/",
        logo: {
          "@type": "ImageObject",
          url: "https://majestic-gensphere.com/favicon.png"
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "Johor Bahru",
          addressRegion: "Johor",
          addressCountry: "MY"
        }
      },
      {
        "@type": "ApartmentComplex",
        "@id": "https://majestic-gensphere.com/#apartment",
        "name": "Gen Sphere (Majestic Gen)",
        "alternateName": ["Majestic Gen Sphere", "Gen Sphere JB"],
        "description": "A luxury residential development and JB property strategically located near the RTS Link Bukit Chagar and JB CIQ. The premier SG JB Condo choice for commuters and investors.",
        "url": "https://majestic-gensphere.com/",
        "image": "https://majestic-gensphere.com/static/media/Swimming-Pool.f155489c01ceec9a3615.jpg",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Bukit Chagar",
          "addressLocality": "Johor Bahru",
          "addressRegion": "Johor",
          "postalCode": "80000",
          "addressCountry": "MY"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "1.4647",
          "longitude": "103.7636"
        },
        "amenityFeature": [
          { "@type": "LocationFeatureSpecification", "name": "RTS Link Bukit Chagar", "value": "Walking Distance" },
          { "@type": "LocationFeatureSpecification", "name": "JB Custom / CIQ", "value": "Near" }
        ]
      },
    ]
  };

  return (
    <div>
      <Helmet>
        <title>Majestic Gen Sphere | Gen Sphere</title>
        <meta
          name="description"
          content="Prestigious residence near JB Sentral and RTS Bukit Chagar."
        />
        <link rel="preload" as="image" href={bannerUrl} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Helmet>

      {/* --- Page Content --- */}
      <div className="majestic-app-root">
        <Navbar
          navLinks={genSphereNavLinks}
        />
        <Banner
          image={bannerUrl}
          title={<><span>Majestic</span> Gen Sphere</>}
          subtitle="A step closer to future lifestyle on Malaysia-Singapore Border."
          location="Johor Bahru"
          learnMoreLink="#project-highlights-section"
          registerLink="#application-form-section"
          primaryColor={accentColor}
          secondaryColor="#fff"
        />
        <div className="orderSwapping">

          <Intro
            paragraphs={genSphereIntro}
            accentColor={accentColor}
          />
          <ProjectHighlightCard
            title={<>What's Special <span className="ph-title-break">About <span className="highlight">Gen Sphere</span></span></>}
            titleColor="#f5f5f7"
            cardTitleColor="#fff"
            cardDescColor="#86868b"
            accentColor={accentColor}
            highlights={genSphereHighlights}
          />
        </div>
        <div className="floor-plan-section">
          <FloorPlanCard
            title="Unit Layouts"
            description="Thoughtfully Designed Floor Plans for Every Home"
            layouts={genSphereUnitLayouts}
            accentColor={accentColor}
          />
        </div>
        <Map
          title="Prime Location"
          description="Seamlessly Connected to Work, Life, and Leisure"
          mapSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63816.35166687337!2d103.69153074863281!3d1.4606040000000202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1300532f7647%3A0xfd5dd2ad828de3d0!2sGen%20Sphere%20by%20Majestic%20Gen!5e0!3m2!1sen!2smy!4v1768667541256!5m2!1sen!2smy"
          address={<>Jalan Lepas<br />Tanjung Puteri<br />80300 Johor Bahru</>}
          directionLink="https://www.google.com/maps/place/Gen+Sphere+by+Majestic+Gen/@1.460604,103.767748,12z/data=!4m6!3m5!1s0x31da1300532f7647:0xfd5dd2ad828de3d0!8m2!3d1.460604!4d103.7677484!16s%2Fg%2F11md2rwjqg?hl=en&entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoKLDEwMDc5MjA2N0gBUAM%3D"
        />
        <ApplicationForm
          title="Arrange a Private Viewing"
          description="Your First Step Toward Exceptional Living. Don’t Miss the Opportunity to Explore Limited Availability Units."
          unitLayouts={genSphereUnitLayouts}
          accentColor={accentColor}
        />
        <FAB />
        <Footer />
      </div>
    </div>
  );
}

export default Majestic;